import { Box, Container, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import uploadImage from "../../../image/wmremove-transformed-Photorooms.jpg";
import {
  wholesalerEditRequest,
  wholesalerResetState,
  wholesalerViewRequest,
} from "../../../redux/wholesaler/WholesalerAction";
import {
  convertTo24HourFormat,
  formatToAMPM,
} from "../../constant/commonTimeFormat";
import {
  handleFileChange,
  convertImageToBase64,
  handleProofChangeMultiImage,
  convertProofToBase64MultiImage,
  removeProofImage,
} from "../../constant/commonFileUpload";
import "../../../style/style.css";
import { StyledContainer, styles } from "../../components/formStyles";
import CustomButton from "../../constant/commonButton";
import ReusableFormFields from "../../constant/reusableFormFields";
import { APP_LINKS } from "../../global/wholeSalerMenuItems";
import { mapBackendMessage } from "../../notification/BackendMessage";
import CloseIcon from "@mui/icons-material/Close";
import CommonDialog from "../../notification/ErrorDialogbox";
import CommonSnackbar from "../../notification/Snackbar";
import ImagePreviewDialog from "../../constant/commonImageDialog";
import pdf from "../../../image/pdf.jpg";

const EditWholesaler = () => {
  const {
    register,
    handleSubmit,
    setValue,
    control,
    setError,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [imageFileName, setImageFileName] = useState("");
  const [proofFileName, setProofFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [proofSelected, setProofSelected] = useState([]);
  const [imagePreview, setImagePreview] = useState(null);
  const [proofPreview, setProofPreview] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(true);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState([]);
  const [existingProofUrls, setExistingProofUrls] = useState([]);
  const [newProofBase64, setNewProofBase64] = useState([]);
  const [isImageRemove, setIsImageRemove] = useState(false);
  const [isImageOnlySave, setIsImageOnlySave] = useState(false);

  const wholesalerState = useSelector(
    (state) => state?.wholesaler?.viewWholesaler?.data || {}
  );
  const wholesalerList = wholesalerState || [];
  const editWholesalerState = useSelector(
    (state) => state?.wholesaler?.editWholesaler
  );
  const id = useSelector(
    (state) => state?.values?.loginValues?.[0]?.wholesaler_id
  );

  const handleCancel = () => {
    navigate(APP_LINKS.WHOLESALERDASHBOARD);
  };

  const inputFields = [
    {
      name: "name",
      label: "Company Name",
    },
    {
      name: "license_no",
      label: "License No",
      rules: {
        required: "License No is required",
        pattern: {
          value: /^[A-Z0-9-]{5,15}$/,
          message:
            "License No must be 5-15 characters (letters, numbers, hyphens).",
        },
      },
    },
    {
      name: "tax_id",
      label: "Tax ID",
      rules: {
        required: "Tax ID is required",
        pattern: {
          value: /^[0-9]{9,12}$/,
          message: "Tax ID must be 9-12 digits long.",
        },
      },
    },
    {
      name: "company_reg_no",
      label: "Company Reg No",
      rules: {
        required: "Company Reg No is required",
        pattern: {
          value: /^[A-Z0-9]{8,12}$/,
          message: "Company Reg No must be 8-12 uppercase letters or numbers.",
        },
      },
    },
    {
      name: "first_name",
      label: "First Name",
    },
    {
      name: "last_name",
      label: "Last Name",
    },
    {
      name: "email",
      label: "Email Address",
      rules: {
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email format",
        },
      },
    },
    {
      name: "contact",
      label: "Phone No",
      rules: {
        required: "Phone No is required",
        pattern: { value: /^\d{8,}$/, message: "Invalid Phone Number" },
      },
    },
    {
      name: "address",
      label: "Address",
      size: "extraLarge",
    },
    {
      name: "working_time",
      label: "Working Time",
      type: "group",
      fields: [
        {
          name: "open_time",
          label: "Start of Workday",
          type: "time",
        },
        {
          name: "close_time",
          label: "End of Workday",
          type: "time",
        },
      ],
    },
    {
      name: "user_type",
      label: "User  Type",
      defaultValue: "3",
      rules: { required: "User Type is required" },
      display: false,
    },
  ];

  const handleImageUpload = (event) => {
    handleFileChange(
      event,
      setSelectedFile,
      setImagePreview,
      setImageFileName,
      showSnackbar
    );
  };

  useEffect(() => {
    const existingImageUrl = "https://example.com/image.jpg";
    convertImageToBase64(existingImageUrl, (base64) => {
      setSelectedFile(base64);
    });
  }, []);

  const handleProofUpload = (event) => {
    handleProofChangeMultiImage(
      event,
      setNewProofBase64,
      setProofPreview,
      setProofFileName,
      showSnackbar,
      setValue
    );
    setIsImageRemove(false);
  };

  useEffect(() => {
    if (id) {
      dispatch(wholesalerViewRequest(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (wholesalerList) {
      setValue("first_name", wholesalerList?.first_name);
      setValue("last_name", wholesalerList?.last_name);
      setValue("name", wholesalerList?.name);
      setValue("address", wholesalerList?.address);
      setValue("email", wholesalerList?.email);
      setValue("license_no", wholesalerList?.license_no);
      setValue("tax_id", wholesalerList?.tax_id);
      setValue("company_reg_no", wholesalerList?.company_reg_no);
      setValue("contact", wholesalerList?.contact);
      setValue("working_time", wholesalerList?.working_time);
      setValue("status", wholesalerList?.status);
      const imageUrl = wholesalerList?.prof_image;
      if (imageUrl) {
        if (imageUrl.startsWith("data:image")) {
          setSelectedFile(imageUrl.split(",")[1]);
          setImagePreview(imageUrl);
        } else {
          setImagePreview(imageUrl);
          convertImageToBase64(imageUrl).then((base64) => {
            if (base64) {
              setSelectedFile(base64);
            }
          });
        }
      } else {
        setImagePreview(uploadImage);
        setSelectedFile(null);
      }

      const proofUrls = Array.isArray(wholesalerList?.govt_id_image)
        ? wholesalerList.govt_id_image.filter((img) => img !== null)
        : wholesalerList?.govt_id_image
        ? [wholesalerList.govt_id_image]
        : [];

      const validProofUrls = proofUrls.filter((url) => url !== uploadImage);
      const convertProofPromises = validProofUrls.map((url) =>
        convertProofToBase64MultiImage(url)
      );

      Promise.all(convertProofPromises).then((base64ProofImages) => {
        setExistingProofUrls(base64ProofImages);
        setProofPreview(validProofUrls);
      });
    }
  }, [wholesalerList, setValue]);

  useEffect(() => {
    if (wholesalerState?.working_time) {
      const timeParts = wholesalerState?.working_time.split(" to ");

      if (timeParts.length === 2) {
        setValue("open_time", convertTo24HourFormat(timeParts[0]), {
          shouldDirty: true,
          shouldValidate: true,
        });
        setValue("close_time", convertTo24HourFormat(timeParts[1]), {
          shouldDirty: true,
          shouldValidate: true,
        });
      } else {
        setValue("open_time", "", { shouldDirty: true, shouldValidate: true });
        setValue("close_time", "", { shouldDirty: true, shouldValidate: true });
      }
    }
  }, [wholesalerState?.working_time, setValue]);

  const onSubmit = (data) => {
    const {
      govt_id_image,
      profile_image,
      bar_image,
      created_at,
      ...filteredData
    } = data;

    let govtImages = [...existingProofUrls];

    if (!isImageRemove) {
      newProofBase64.forEach((newImage) => {
        if (!govtImages.includes(newImage)) {
          govtImages.push(newImage);
        }
      });
    }

    const editRequestData = {
      ...filteredData,
      working_time: `${formatToAMPM(filteredData.open_time)} to ${formatToAMPM(
        filteredData.close_time
      )}`,
      tax_id: filteredData.tax_id?.replace(/\s+/g, ""),
      company_reg_no: filteredData.company_reg_no?.replace(/\s+/g, ""),
      license_no: filteredData.license_no?.replace(/\s+/g, ""),
      prof_image: selectedFile
        ? selectedFile
        : wholesalerList?.prof_image || null,
      govt_img_url: govtImages,
      id,
    };

    dispatch(wholesalerEditRequest(id, editRequestData));
    setNewProofBase64([]);
  };

  const handleImage = () => {
    if (selectedFile || wholesalerList?.prof_image) {
      const data = {
        ...wholesalerList,
        prof_image: selectedFile ? selectedFile : wholesalerList?.prof_image,
      };
      setIsImageOnlySave(true);
      onSubmit(data);
      showSnackbar("Image saved successfully.", "success");
    } else {
      showSnackbar("Please choose a file before saving.", "error");
    }
  };

  const proofImage = () => {
    let govtImages = [...existingProofUrls];

    if (newProofBase64.length > 0) {
      govtImages = [...govtImages, ...newProofBase64];
    }

    const data = {
      ...wholesalerList,
      govt_img_url: govtImages,
    };
    setIsImageOnlySave(true);
    onSubmit(data);
    showSnackbar("Proof documents saved successfully.", "success");
  };

  const handleEditWholesalerResponse = () => {
    if (editWholesalerState?.error) {
      const errorFields = editWholesalerState?.errorFields || {};
      if (Object.keys(errorFields).length > 0) {
        Object.keys(errorFields).forEach((field) => {
          setError(field, {
            type: "manual",
            message: errorFields[field],
          });
        });
      } else {
        const customMessage = mapBackendMessage(
          editWholesalerState?.errormessage ||
            "An error occurred while updating the wholesaler."
        );
        setDialogMessage(customMessage);
        setIsSuccess(false);
        setDialogOpen(true);
        dispatch(wholesalerViewRequest(id));
      }
    } else if (editWholesalerState?.success) {
      if (isImageOnlySave) {
        showSnackbar("Image/Proof saved successfully!", "success");
      } else {
        setDialogMessage("Profile updated successfully");
        setIsSuccess(true);
        setDialogOpen(true);
      }
      dispatch(wholesalerResetState());
      dispatch(wholesalerViewRequest(id));
      setIsImageOnlySave(false);
    }
  };

  useEffect(() => {
    handleEditWholesalerResponse();
  }, [editWholesalerState]);

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleImageClick = (image, isPdf = false) => {
    if (isPdf) {
      window.open(image, "_blank");
    } else if (image !== uploadImage) {
      setSelectedImage(image);
      setOpen(true);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
            <Box className="headingTable">
              <h1> Account Details </h1>
              <Typography variant="p" gutterBottom sx={styles.photoHeading}>
                Upload Image of Wholesaler
              </Typography>
            </Box>
            <Box>
              <StyledContainer>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={2} xl={2}>
                    <img
                      src={imagePreview || uploadImage}
                      alt="Image"
                      width={80}
                      height={80}
                      style={styles.image}
                      onClick={() => handleImageClick(imagePreview)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
                    <Typography
                      variant="p"
                      gutterBottom
                      sx={styles.photoContent}
                    >
                      Upload Actual Photos of Wholesaler, size less than 2MB
                    </Typography>
                    <Box sx={styles.fileButtonContainer}>
                      <CustomButton
                        variant="outlined"
                        component="label"
                        size="small"
                        buttonStyle="chooseFileButton"
                      >
                        Choose File
                        <input
                          type="file"
                          hidden
                          onChange={handleImageUpload}
                          aria-hidden="false"
                        />
                      </CustomButton>
                      <CustomButton
                        variant="contained"
                        size="small"
                        buttonStyle="fileNameButton"
                        selectedFile={Boolean(selectedFile)}
                        // disabled={!imageFileName}
                      >
                        {imageFileName || "No File Chosen"}
                      </CustomButton>
                    </Box>
                    <Box sx={styles.saveButtonContainer}>
                      <CustomButton
                        text="Save"
                        buttonStyle="saveButton"
                        onClick={handleImage}
                        size="small"
                      >
                        Save
                      </CustomButton>
                    </Box>
                  </Grid>
                </Grid>
              </StyledContainer>
            </Box>
            <Box>
              <Typography variant="body2" gutterBottom sx={styles.note}>
                <span style={{ color: "red" }}>Note:</span> Only JPEG or PNG
                format is supported <span style={{ color: "red" }}>*</span>
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={5}>
            <Box sx={{ marginTop: "84px" }}>
              <Typography variant="p" gutterBottom sx={styles.photoHeading}>
                Upload Govt ID Proof Of Bar/club
              </Typography>
              <StyledContainer>
                <Grid container spacing={6}>
                  {proofPreview.length > 0 &&
                  proofPreview.some((file) => file) ? (
                    proofPreview.map((fileObj, index) => {
                      const fileUrl =
                        typeof fileObj === "string" ? fileObj : fileObj?.url;
                      const isPdf =
                        typeof fileObj === "string"
                          ? fileObj.toLowerCase().endsWith(".pdf")
                          : fileObj?.isPdf ?? false;

                      return (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={4}
                          lg={2}
                          xl={2}
                          key={index}
                        >
                          <Box sx={styles.imageUploadClosePosition}>
                            {isPdf ? (
                              <img
                                src={pdf}
                                alt={`PDF ${index + 1}`}
                                width={80}
                                height={80}
                                style={styles.imageUploadCloseContain}
                                onClick={() => {
                                  handleImageClick(fileUrl, true);
                                }}
                              />
                            ) : (
                              <img
                                src={fileUrl}
                                alt={`Proof ${index + 1}`}
                                width={80}
                                height={80}
                                style={styles.imageUploadCloseContain}
                                onClick={() => {
                                  handleImageClick(fileUrl, false);
                                }}
                              />
                            )}
                            {/* Close (Remove) Button */}
                            <button
                              type="button"
                              onClick={() => {
                                setIsImageRemove(true);
                                removeProofImage(
                                  index,
                                  setProofSelected,
                                  setProofPreview,
                                  setExistingProofUrls
                                );
                              }}
                              style={styles.imageUploadClose}
                            >
                              <CloseIcon fontSize="small" />
                            </button>
                          </Box>
                        </Grid>
                      );
                    })
                  ) : (
                    <Grid item xs={12} sm={6} md={4} lg={2} xl={2}>
                      <img
                        src={uploadImage}
                        alt="Default Upload Image"
                        width={80}
                        height={80}
                        style={styles.image}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={12} md={12} lg={10} xl={10}>
                    <Typography
                      variant="p"
                      gutterBottom
                      sx={styles.photoContent}
                    >
                      Upload Actual Photos of Proof, size less than 2MB
                    </Typography>
                    <Box sx={styles.fileButtonContainer}>
                      <CustomButton
                        text="Choose File"
                        variant="outlined"
                        component="label"
                        size="small"
                        buttonStyle="chooseFileButton"
                      >
                        Choose File
                        <input
                          type="file"
                          hidden
                          onChange={handleProofUpload}
                          aria-hidden="false"
                        />
                      </CustomButton>
                      <CustomButton
                        variant="contained"
                        size="small"
                        buttonStyle="fileNameButton"
                        selectedFile={Boolean(proofSelected)}
                        z
                      >
                        {proofFileName || "No File Chosen"}
                      </CustomButton>
                    </Box>
                    <Box sx={styles.saveButtonContainer}>
                      <CustomButton
                        text="Save"
                        buttonStyle="saveButton"
                        onClick={proofImage}
                        size="small"
                      >
                        Save
                      </CustomButton>
                    </Box>
                  </Grid>
                </Grid>
              </StyledContainer>
            </Box>
            <Typography variant="body2" gutterBottom sx={styles.note}>
              <span style={{ color: "red" }}>Note:</span> Only JPEG, PDF & PNG
              format is supported <span style={{ color: "red" }}>*</span>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
            <ReusableFormFields
              inputFields={inputFields}
              control={control}
              errors={errors}
              register={register}
              setValue={setValue}
            />
            {/* Submit Button */}
            <Box sx={styles.submitGap}>
              <Grid container spacing={2} item xs={12}>
                <Grid item xs={6}>
                  <CustomButton
                    text="Submit"
                    size="medium"
                    type="submit"
                    buttonStyle="StyledButton"
                    disabled={editWholesalerState?.inProgress}
                    loading={editWholesalerState?.inProgress}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CustomButton
                    text="Cancel"
                    variant="contained"
                    size="medium"
                    fullWidth
                    buttonStyle="style1"
                    onClick={handleCancel}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </form>
      {/* Snackbar */}
      <CommonSnackbar
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />

      {/* Dialog */}
      <CommonDialog
        open={dialogOpen}
        isSuccess={isSuccess}
        onClose={handleDialogClose}
        redirectPath={APP_LINKS.WHOLESALERDASHBOARD}
        messageSuccess={dialogMessage}
        messageError={dialogMessage}
      />
      {/* Popup Dialog */}
      <ImagePreviewDialog
        open={open}
        onClose={handleClose}
        selectedImage={selectedImage}
        proofSelected={proofSelected}
      />
    </Container>
  );
};

export default EditWholesaler;
